/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import GraphHorizontal from "./RegionAnalysis/GraphHorizontal";
import GraphStacked from "./RegionAnalysis/GraphStacked";
import GraphLine from "./RegionAnalysis/GraphLine";
import GraphStackedLine from "./RegionAnalysis/GraphStackedLine";
import GraphGroupedLine from "./RegionAnalysis/GraphGroupedLine";
import GraphStackedHorizontal from "./RegionAnalysis/GraphStackedHorizontal";
import GraphPopulation from "./RegionAnalysis/GraphPopulation";
import { regionalanalyseRequest } from "../query-configs/widget.js";
import { useRequest } from "redux-query-react";
import { useSelector } from "react-redux";
import { getRegionalanalyseResult } from "../selectors/widget.js";

const Graph = ({ module, regionIds, setUpdated, setSource }) => {
  const { graphType, dataset } = module;

  const [{ status, isPending }] = useRequest(regionalanalyseRequest(dataset));
  const apiResult = useSelector((state) => getRegionalanalyseResult(state, dataset));

  useEffect(() => {
    if (apiResult) {
      let result = apiResult;
      if (result.updated) {
        let updated = new Date(result.updated);
        setUpdated(updated.toLocaleDateString("no-NO"));
      }
    }
  }, [apiResult, dataset]);

  useEffect(() => {
    if (module.tableId) {
      setSource(`SSB tabell ${module.tableId}`);
    }
    if (module.source) {
      setSource(module.source);
    }
  }, [module]);

  if (isPending)
    return (
      <div className="spinner">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  if (status !== 200) return <p>Problems loading from external api</p>;

  if (graphType === "bar-horizontal") {
    return <GraphHorizontal module={module} regionIds={regionIds} />;
  }
  if (graphType === "bar-stacked") {
    return <GraphStacked module={module} regionIds={regionIds} />;
  }
  if (graphType === "bar-stacked-horizontal") {
    return <GraphStackedHorizontal module={module} regionIds={regionIds} />;
  }
  if (graphType === "bar-stacked-line") {
    return <GraphStackedLine module={module} regionIds={regionIds} />;
  }
  if (graphType === "grouped-line") {
    return <GraphGroupedLine module={module} regionIds={regionIds} />;
  }
  if (graphType === "line") {
    return <GraphLine module={module} regionIds={regionIds} />;
  }
  if (graphType === "population-pyramid") {
    return <GraphPopulation module={module} regionIds={regionIds} />;
  }
};

export default Graph;
